import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
  changeDateFormat,
  checkArray,
  checkNull,
  createSelectOptions,
  decimalValue,
  parseStringToDate,
} from "../../../../../helpers";
import {
  addFinanceSubAccountDetails,
  changeSettingValue,
  saveFinanceSubAccountDetails,
} from "../../../../../Redux/actions";
import Headerbar from "../../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../../Components/InnerLayout/UserInterface";

const AddSubAccount = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { add_accounts_details, is_redirect_accounts_id } = useSelector(
    (state) => state.settingReducer
  );
  const financeAcc = add_accounts_details?.data;
  let { id } = useParams();

  useEffect(() => {
    dispatch(addFinanceSubAccountDetails(`/${id}`));
    dispatch(changeSettingValue("is_redirect_accounts_id", false));
    return () => {
      dispatch(changeSettingValue("add_accounts_details", null));
      dispatch(changeSettingValue("is_redirect_accounts_id", false));
    };
  }, []);
  useEffect(() => {
    if (is_redirect_accounts_id)
      history.push(`/settings/finance/chart-of-accounts/accounts/${id}`);
  }, [is_redirect_accounts_id]);

  const [addAccForm, setaddAccForm] = useState({
    parent_finance_account_id: "",
    account_id: "",
    name: "",
    default_payment_account_id: "",
    payee_id: "",
    opening_balance: "",
    PaymentMethod: "",
    default_deposit_account_id: "",
    opening_balance2: "",
    purchase_value: "",
    salvage_value: "",
    useful_life: "",
    taxable: "",
    is_bank_account: "",
    company_id: "",
    bank_name: "",
    bank_account_no: "",
  });

  useEffect(() => {
    const newAccForm = {
      parent_finance_account_id: checkNull(add_accounts_details?.acid),
      account_id: checkNull(add_accounts_details?.newAccountId),
      // name: checkNull(financeAcc?.name),
      // default_payment_account_id: checkNull(
      //   financeAcc?.default_payment_account_id,
      //   "1"
      // ),
      // payee_id: checkNull(financeAcc?.payee_id),
      // opening_balance: checkNull(financeAcc?.opening_balance),
      // PaymentMethod: checkNull(financeAcc?.PaymentMethod, "1"),
      // default_deposit_account_id: checkNull(
      //   financeAcc?.default_deposit_account_id
      // ),
      // opening_balance2: checkNull(financeAcc?.opening_balance2),
      // purchase_value: checkNull(financeAcc?.purchase_value),
      // salvage_value: checkNull(financeAcc?.salvage_value),
      // useful_life: checkNull(financeAcc?.useful_life),
      // taxable: checkNull(financeAcc?.taxable),
    };
    setaddAccForm(newAccForm);
  }, [financeAcc]);

  const accFormChangeHandler = (input, val) => {
    setaddAccForm((prevState) => ({ ...prevState, [input]: val }));
  };

  const submitAccFormHandler = () => {
    dispatch(saveFinanceSubAccountDetails(`/${id}`, addAccForm));
  };

  const getFormAccAccount = () => {
    let res = null;
    const accPrefix = financeAcc?.prefix ?? "";
    if (accPrefix == "L01") {
      res = (
        <div class="row-fluid shifts">
          <div class="col-md-6">
            <ul class="ingredient-info edit-shift">
              <li>
                <label>Account ID</label>
                <div class="input-group col-md-7">
                  <p>{add_accounts_details?.newAccountId}</p>
                </div>
              </li>
              <li>
                <label class="required">Sub-Account Name</label>
                <div class="input-group col-md-7">
                  <input
                    type="text"
                    name="name"
                    className="required"
                    onChange={(e) =>
                      accFormChangeHandler("name", e?.target?.value)
                    }
                    value={addAccForm?.name}
                  />
                </div>
              </li>
              <li>
                <label class="required">Default Payment Acct.</label>
                <div class="input-group select-div col-md-7">
                  <select
                    name="default_payment_account_id"
                    id="default_payment_account_id"
                    onChange={(e) =>
                      accFormChangeHandler(
                        "default_payment_account_id",
                        e?.target?.value
                      )
                    }
                    value={addAccForm?.default_payment_account_id}
                    className="required"
                  >
                    <option value="">Select</option>
                    {createSelectOptions(
                      add_accounts_details?.default_payment_accounts
                    )}
                  </select>
                </div>
              </li>
              <li>
                <label class="required">Select Payee</label>
                <div class="input-group select-div col-md-7">
                  <select
                    name="payee_id"
                    id="payee_id"
                    onChange={(e) =>
                      accFormChangeHandler("payee_id", e?.target?.value)
                    }
                    value={addAccForm?.payee_id}
                    className="required"
                  >
                    <option value="">Select</option>
                    {createSelectOptions(add_accounts_details?.payees)}
                  </select>
                </div>
              </li>
            </ul>
          </div>
          <div class="btns col-4 d-flex justify-content-start py-4 col-12">
            <input
            className="m-0"
              type="button"
              value="Submit"
              id="submitBut"
              onClick={() => submitAccFormHandler()}
            />
          </div>
        </div>
      );
    } else if (accPrefix == "L04" || accPrefix == "L05") {
      res = (
        <div class="row-fluid shifts">
          <div class="col-md-6">
            <ul class="ingredient-info edit-shift">
              <li>
                <label>Account ID</label>
                <div class="input-group col-md-7">
                  <p>{add_accounts_details?.newAccountId}</p>
                </div>
              </li>
              <li>
                <label class="required">Payee Name</label>
                <div class="input-group col-md-7">
                  <select
                    name="payee_id"
                    id="payee_id"
                    onChange={(e) =>
                      accFormChangeHandler("payee_id", e?.target?.value)
                    }
                    value={addAccForm?.payee_id}
                    className="required"
                  >
                    <option value="">Select</option>
                    {createSelectOptions(add_accounts_details?.payees)}
                  </select>
                </div>
              </li>
              <li>
                <label class="required">Sub-Account Name</label>
                <div class="input-group col-md-7">
                  <input
                    type="text"
                    name="name"
                    className="required"
                    value={addAccForm?.name}
                    onChange={(e) =>
                      accFormChangeHandler("name", e?.target?.value)
                    }
                  />
                </div>
              </li>
              <li>
                <label class="required">Default Payment Acct.</label>
                <div class="input-group select-div col-md-7">
                  <select
                    name="default_payment_account_id"
                    id="default_payment_account_id"
                    value={addAccForm?.default_payment_account_id}
                    className="required"
                    onChange={(e) =>
                      accFormChangeHandler(
                        "default_payment_account_id",
                        e?.target?.value
                      )
                    }
                  >
                    <option value="">Select</option>
                    {createSelectOptions(
                      add_accounts_details?.default_payment_accounts
                    )}
                  </select>
                </div>
              </li>
            </ul>
          </div>

          <div class="clear"> &nbsp; </div>
          <div class="clear"> &nbsp; </div>
          <div class="btns col-4 d-flex justify-content-start py-4 col-12">
            <input
            className="m-0"
              type="button"
              value="Submit"
              id="submitBut"
              onClick={() => submitAccFormHandler()}
            />
            {add_accounts_details?.show && (
              <input type="button" value="Cancel" id="cancelBut"></input>
            )}
          </div>
        </div>
      );
    } else if (accPrefix == "A01" || accPrefix == "A08") {
      res = (
        <div class="row-fluid shifts">
          <div class="col-md-6">
            <ul class="ingredient-info edit-shift">
              <li>
                <label>Account ID</label>
                <div class="input-group col-md-7">
                  <p>{add_accounts_details?.newAccountId}</p>
                </div>
              </li>
              <li>
                <label class="required">Sub-Account Name</label>
                <div class="input-group col-md-7">
                  <input
                    type="text"
                    name="name"
                    className="required"
                    onChange={(e) =>
                      accFormChangeHandler("name", e?.target?.value)
                    }
                    value={addAccForm?.name}
                  />
                </div>
              </li>
              <li>
                <label class="required">Opening Balance</label>
                <div class="input-group col-md-7">
                  <span class="dolor-sign">{add_accounts_details?.cS}</span>
                  <input
                    type="text"
                    name="opening_balance"
                    onChange={(e) =>
                      accFormChangeHandler("opening_balance", e?.target?.value)
                    }
                    className="required currency"
                    value={addAccForm?.opening_balance}
                  />
                </div>
              </li>
            </ul>
          </div>

          <div class="col-md-6 right-section">
            <ul class="ingredient-info edit-shift">
              <li class="blank-list">
                <label> </label>
                <div class="input-group col-md-7">
                  <p> </p>
                </div>
              </li>
              <li>
                <label class="required">Linked Payment Method(s)</label>
                <div class="input-group col-md-7">
                  <select
                    name="PaymentMethod"
                    id="PaymentMethod"
                    onChange={(e) =>
                      accFormChangeHandler("PaymentMethod", e?.target?.value)
                    }
                    value={addAccForm?.PaymentMethod}
                    className="required"
                  >
                    <option value="">Select</option>
                    {createSelectOptions(add_accounts_details?.paymentMethods)}
                  </select>
                  {/* <?php echo $this->Form->input('PaymentMethod.PaymentMethod', array('class' => 'required multiPm', 'multiple', */}
                  {/* 'options' => $paymentMethods, 'div'=>false, 'label'=>false))?> */}
                </div>
              </li>
              <li>
                <label class="required">Default Deposit Account</label>
                <div class="input-group select-div col-md-7">
                  <select
                    name="default_deposit_account_id"
                    id="default_deposit_account_id"
                    onChange={(e) =>
                      accFormChangeHandler(
                        "default_deposit_account_id",
                        e?.target?.value
                      )
                    }
                    value={addAccForm?.default_deposit_account_id}
                    className="required"
                  >
                    <option value="">Select</option>
                    {createSelectOptions(add_accounts_details?.cces)}
                  </select>
                </div>
              </li>
            </ul>
          </div>
          <div class="clear"> &nbsp; </div>
          <div class="clear"> &nbsp; </div>
          <div class="btns col-4 d-flex justify-content-start py-4 col-12">
            <input
              type="submit"
              value="Submit"
              id="submitBut"
              onClick={() => submitAccFormHandler()}
            />
            {add_accounts_details?.show && (
              <input type="button" value="Cancel" id="cancelBut"></input>
            )}
          </div>
        </div>
      );
    } else if (accPrefix == "A11" || accPrefix == "A13") {
      res = (
        <div class="row-fluid shifts">
          <div class="col-md-6">
            <ul class="ingredient-info edit-shift">
              <li>
                <label>Account ID</label>
                <div class="input-group col-md-7">
                  <p>{add_accounts_details?.newAccountId}</p>
                </div>
              </li>
              <li>
                <label class="required">Sub-Account Name</label>
                <div class="input-group col-md-7">
                  <input
                    type="text"
                    name="name"
                    className="required"
                    onChange={(e) =>
                      accFormChangeHandler("name", e?.target?.value)
                    }
                    value={addAccForm?.name}
                  />
                </div>
              </li>
              <li>
                <label class="required">Opening Balance</label>
                <div class="input-group col-md-7">
                  <span class="dolor-sign">{add_accounts_details?.cS}</span>
                  <input
                    type="text"
                    onChange={(e) =>
                      accFormChangeHandler("opening_balance2", e?.target?.value)
                    }
                    name="opening_balance2"
                    className="required currency"
                    value={addAccForm?.opening_balance2}
                  />
                </div>
              </li>
            </ul>
          </div>

          <div class="clear"> &nbsp; </div>
          <div class="clear"> &nbsp; </div>
          <div class="btns col-4 d-flex justify-content-start py-4 col-12">
            <input
            className="m-0"
              type="button"
              value="Submit"
              id="submitBut"
              onClick={() => submitAccFormHandler()}
            />
            {add_accounts_details?.show && (
              <input type="button" value="Cancel" id="cancelBut"></input>
            )}
          </div>
        </div>
      );
    } else if (accPrefix == "A04" || accPrefix == "A07" || accPrefix == "A17") {
      res = (
        <div class="row-fluid shifts">
          <div class="col-md-6">
            <ul class="ingredient-info edit-shift">
              <li>
                <label>Investment ID</label>
                <div class="input-group col-md-7">
                  <p>{add_accounts_details?.newAccountId}</p>
                </div>
              </li>
              <li>
                <label class="required">Investment Name</label>
                <div class="input-group col-md-7">
                  <input
                    type="text"
                    name="name"
                    className="required"
                    onChange={(e) =>
                      accFormChangeHandler("name", e?.target?.value)
                    }
                    value={addAccForm?.name}
                  />
                </div>
              </li>
              <li>
                <label class="">Purchase Value</label>
                <div class="input-group col-md-7">
                  {decimalValue(
                    financeAcc?.purchase_value,
                    2,
                    add_accounts_details?.currency
                  )}
                </div>
              </li>
              <li>
                <label class="">Current Value</label>
                <div class="input-group col-md-7">
                  {decimalValue(
                    financeAcc?.current_value,
                    2,
                    add_accounts_details?.currency
                  )}
                </div>
              </li>
              <li>
                <label class="">Realized P&L</label>
                <div class="input-group col-md-7">
                  {decimalValue(
                    financeAcc?.current_value,
                    2,
                    add_accounts_details?.realized_pl
                  )}
                </div>
              </li>
              <li>
                <label class="required">Unrealized P&L</label>
                <div class="input-group col-md-7">
                  {decimalValue(
                    financeAcc?.current_value,
                    2,
                    add_accounts_details?.unrealized_pl
                  )}
                </div>
              </li>
            </ul>
          </div>

          <div class="clear"> &nbsp; </div>
          <div class="clear"> &nbsp; </div>
          <div class="btns col-4 d-flex justify-content-start py-4 col-12">
            <input
            className="m-0"
              type="button"
              value="Submit"
              id="submitBut"
              onClick={() => submitAccFormHandler()}
            />
            {add_accounts_details?.show && (
              <input type="button" value="Cancel" id="cancelBut"></input>
            )}
          </div>
        </div>
      );
    } else if (accPrefix == "A05") {
      res = (
        <div class="row-fluid shifts">
          <div class="col-md-6">
            <ul class="ingredient-info edit-shift">
              <li>
                <label>Asset ID</label>
                <div class="input-group col-md-7">
                  <p>{add_accounts_details?.newAccountId}</p>
                </div>
              </li>
              <li>
                <label class="required">Asset Name</label>
                <input
                  type="text"
                  name="name"
                  className="required"
                  onChange={(e) =>
                    accFormChangeHandler("name", e?.target?.value)
                  }
                  value={addAccForm?.name}
                />
              </li>
              <li>
                <label class="">Purchase Value</label>
                <div class="input-group col-md-7">
                  <input
                    type="text"
                    name="purchase_value"
                    className="currency"
                    onChange={(e) =>
                      accFormChangeHandler("purchase_value", e?.target?.value)
                    }
                    value={addAccForm?.purchase_value}
                  />
                </div>
              </li>
              <li>
                <label class="">Salvage Value</label>
                <div class="input-group col-md-7">
                  <input
                    type="text"
                    name="salvage_value"
                    className="currency"
                    onChange={(e) =>
                      accFormChangeHandler("salvage_value", e?.target?.value)
                    }
                    value={addAccForm?.salvage_value}
                  />
                </div>
              </li>
              <li>
                <label class="required">Useful Life of Asset (Years)</label>
                <div class="input-group col-md-7">
                  <input
                    type="text"
                    name="useful_life"
                    className="required"
                    onChange={(e) =>
                      accFormChangeHandler("useful_life", e?.target?.value)
                    }
                    value={addAccForm?.useful_life}
                  />
                </div>
              </li>
              <li>
                <label class="required">Default payment account</label>
                <div class="input-group col-md-7">
                  <select
                    name="default_deposit_account_id"
                    id="default_deposit_account_id"
                    value={addAccForm?.default_deposit_account_id}
                    onChange={(e) =>
                      accFormChangeHandler(
                        "default_deposit_account_id",
                        e?.target?.value
                      )
                    }
                    className="required"
                  >
                    <option value="">Select</option>
                    {createSelectOptions(add_accounts_details?.adhocs)}
                  </select>
                </div>
              </li>
            </ul>
          </div>

          <div class="clear"> &nbsp; </div>
          <div class="clear"> &nbsp; </div>
          <div class="btns col-4 d-flex justify-content-start py-4 col-12">
            <input
            className="m-0"
              type="button"
              value="Submit"
              id="submitBut"
              onClick={() => submitAccFormHandler()}
            />
            {add_accounts_details?.show && (
              <input type="button" value="Cancel" id="cancelBut"></input>
            )}
          </div>
        </div>
      );
    } else if (accPrefix == "A06") {
      res = (
        <div class="row-fluid shifts">
          <div class="col-md-6">
            <ul class="ingredient-info edit-shift">
              <li>
                <label>Asset ID</label>
                <div class="input-group col-md-7">
                  <p>{add_accounts_details?.newAccountId}</p>
                </div>
              </li>
              <li>
                <label class="required">Deposit Name</label>
                <div class="input-group col-md-7">
                  <input
                    type="text"
                    name="name"
                    className="required"
                    onChange={(e) =>
                      accFormChangeHandler("name", e?.target?.value)
                    }
                    value={addAccForm?.name}
                  />
                </div>
              </li>
              <li>
                <label class="required">Deposit Amount</label>
                <div class="input-group col-md-7">
                  <input
                    type="text"
                    name="opening_balance"
                    className="required"
                    onChange={(e) =>
                      accFormChangeHandler("opening_balance", e?.target?.value)
                    }
                    value={addAccForm?.opening_balance}
                  />
                </div>
              </li>
            </ul>
          </div>

          <div class="clear"> &nbsp; </div>
          <div class="clear"> &nbsp; </div>
          <div class="btns col-4 d-flex justify-content-start py-4 col-12">
            <input
            className="m-0"
              type="button"
              value="Submit"
              id="submitBut"
              onClick={() => submitAccFormHandler()}
            />
            {add_accounts_details?.show && (
              <input type="button" value="Cancel" id="cancelBut"></input>
            )}
          </div>
        </div>
      );
    } else if (accPrefix == "E01") {
      res = (
        <div class="row-fluid shifts">
          <div class="col-md-6">
            <ul class="ingredient-info edit-shift">
              <li>
                <label>Issuance ID</label>
                <div class="input-group col-md-7">
                  <p>{add_accounts_details?.newAccountId}</p>
                </div>
              </li>
              <li>
                <label class="required">Issuance Name</label>
                <div class="input-group col-md-7">
                  <input
                    type="text"
                    name="name"
                    className="required"
                    onChange={(e) =>
                      accFormChangeHandler("name", e?.target?.value)
                    }
                    value={addAccForm?.name}
                  />
                </div>
              </li>
              <li>
                <label class="required">Shares Issued</label>
                <div class="input-group col-md-7">
                  <input
                    type="number"
                    name="purchase_value"
                    className="required number_format currency"
                    onChange={(e) =>
                      accFormChangeHandler("purchase_value", e?.target?.value)
                    }
                    value={addAccForm?.purchase_value}
                  />
                </div>
              </li>
              <li>
                <label>Par Value Per Share</label>
                <div class="input-group col-md-7">
                  <p>
                    {decimalValue(
                      add_accounts_details?.par_value,
                      2,
                      add_accounts_details?.currency
                    )}
                  </p>
                </div>
              </li>
            </ul>
          </div>

          <div class="clear"> &nbsp; </div>
          <div class="clear"> &nbsp; </div>
          <div class="btns col-4 d-flex justify-content-start py-4 col-12">
            <input
            className="m-0"
              type="button"
              value="Submit"
              id="submitBut"
              onClick={() => submitAccFormHandler()}
            />
            {add_accounts_details?.show && (
              <input type="button" value="Cancel" id="cancelBut"></input>
            )}
          </div>
        </div>
      );
    } else if (financeAcc?.finance_type_id == "1") {
      res = (
        <div class="row-fluid shifts">
          <div class="col-md-6">
            <ul class="ingredient-info edit-shift">
              <li>
                <label>Account ID</label>
                <div class="input-group col-md-7">
                  <p>{add_accounts_details?.newAccountId}</p>
                </div>
              </li>
              <li>
                <label class="required">Sub-Account Name</label>
                <div class="input-group col-md-7">
                  <input
                    type="text"
                    className="required"
                    name="name"
                    onChange={(e) =>
                      accFormChangeHandler("name", e?.target?.value)
                    }
                    value={addAccForm?.name}
                  />
                </div>
              </li>
              <li>
                <label class="required">Taxable?</label>
                <div class="input-group col-md-7 select-div">
                  <select
                    name="taxable"
                    id="taxable"
                    onChange={(e) =>
                      accFormChangeHandler("taxable", e?.target?.value)
                    }
                    value={addAccForm?.taxable}
                    className="required"
                  >
                    <option value="">Select</option>
                    {createSelectOptions({ 0: "No", 1: "Yes" })}
                  </select>
                </div>
              </li>
            </ul>
          </div>

          <div class="clear"> &nbsp; </div>
          <div class="clear"> &nbsp; </div>
          <div class="btns col-4 d-flex justify-content-start py-4 col-12">
            <input              className="m-0"
              type="button"
              value="Submit"
              id="submitBut"
              onClick={() => submitAccFormHandler()}
            />
            {add_accounts_details?.show && (
              <input type="button" value="Cancel" id="cancelBut" />
            )}
          </div>
        </div>
      );
    } else if (financeAcc?.finance_type_id == "2") {
      res = (
        <div class="row-fluid shifts">
          <div class="col-md-6">
            <ul class="ingredient-info edit-shift">
              <li>
                <label>Account ID</label>
                <div class="input-group col-md-7">
                  <p>{add_accounts_details?.newAccountId}</p>
                </div>
              </li>
              <li>
                <label class="required">Sub-Account Name</label>
                <div class="input-group col-md-7">
                  <input
                    type="text"
                    name="name"
                    className="required"
                    onChange={(e) =>
                      accFormChangeHandler("name", e?.target?.value)
                    }
                    value={addAccForm?.name}
                  />
                </div>
              </li>
            </ul>
          </div>

          <div class="clear"> &nbsp; </div>
          <div class="clear"> &nbsp; </div>
          <div class="btns col-4 d-flex justify-content-start py-4 col-12">
            <input              className="m-0"
              type="button"
              value="Submit"
              id="submitBut"
              onClick={() => submitAccFormHandler()}
            />
            {add_accounts_details?.show && (
              <input type="button" value="Cancel" id="cancelBut"></input>
            )}
          </div>
        </div>
      );
    } else {
      res = (
        <div class="row-fluid shifts">
          <div class="col-md-6">
            <ul class="ingredient-info edit-shift">
              <li>
                <label>Account ID</label>
                <div class="input-group col-md-7">
                  <p>{add_accounts_details?.newAccountId}</p>
                </div>
              </li>
              <li>
                <label class="required">Sub-Account Name</label>
                <div class="input-group col-md-7">
                  <input
                    type="text"
                    name="name"
                    className="required"
                    onChange={(e) =>
                      accFormChangeHandler("name", e?.target?.value)
                    }
                    value={addAccForm?.name}
                  />
                </div>
              </li>
              <li>
                <label class="required">Bank Account?</label>
                <div class="input-group select-div col-md-7">
                  <select
                    name="is_bank_account"
                    id="is_bank_account"
                    onChange={(e) =>
                      accFormChangeHandler("is_bank_account", e?.target?.value)
                    }
                    value={addAccForm?.is_bank_account}
                    className="required isBankAccount"
                  >
                    <option value="">Select</option>
                    {createSelectOptions({ 0: "No", 1: "Yes" })}
                  </select>
                </div>
              </li>

              <li class="bankDiv">
                <label class="required">Company ID</label>
                <div class="input-group col-md-7">
                  <input
                    type="text"
                    name="company_id"
                    className="required"
                    onChange={(e) =>
                      accFormChangeHandler("company_id", e?.target?.value)
                    }
                    value={addAccForm?.company_id}
                  />
                </div>
              </li>

              <li style="display: none" class="nonBankDiv">
                <label class="required">Opening Balance</label>
                <div class="input-group col-md-7">
                  <span class="dolor-sign">{add_accounts_details?.cS}</span>
                  <input
                    type="text"
                    name="opening_balance"
                    className="required"
                    onChange={(e) =>
                      accFormChangeHandler("opening_balance", e?.target?.value)
                    }
                    value={addAccForm?.opening_balance}
                  />
                </div>
              </li>
            </ul>
          </div>

          <div class="col-md-6 right-section bankDiv">
            <ul class="ingredient-info edit-shift">
              <li>
                <label class="required">Custodian/Bank Name</label>
                <div class="input-group select-div col-md-7">
                  <select
                    name="is_bank_account"
                    id="is_bank_account"
                    onChange={(e) =>
                      accFormChangeHandler("bank_name", e?.target?.value)
                    }
                    value={addAccForm?.bank_name}
                    className="required"
                  >
                    <option value="">Select</option>
                    {createSelectOptions(add_accounts_details?.banks)}
                  </select>
                </div>
              </li>
              <li>
                <label class="required">Account Number</label>
                <div class="input-group col-md-7">
                  <input
                    type="text"
                    name="bank_account_no"
                    className="required"
                    onChange={(e) =>
                      accFormChangeHandler("bank_account_no", e?.target?.value)
                    }
                    value={addAccForm?.bank_account_no}
                  />
                </div>
              </li>
              <li>
                <label class="required">Opening Balance</label>
                <div class="input-group col-md-7">
                  <span class="dolor-sign">{add_accounts_details?.cS}</span>
                  <input
                    type="text"
                    name="opening_balance2"
                    className="required"
                    onChange={(e) =>
                      accFormChangeHandler("opening_balance2", e?.target?.value)
                    }
                    value={addAccForm?.opening_balance2}
                  />
                </div>
              </li>
            </ul>
          </div>

          <div class="clear"> &nbsp; </div>
          <div class="clear"> &nbsp; </div>
          <div class="btns col-4 d-flex justify-content-start py-4 col-12">
            <input              className="m-0"
              type="button"
              value="Submit"
              id="submitBut"
              onClick={() => submitAccFormHandler()}
            />
            {add_accounts_details?.show && (
              <input type="button" value="Cancel" id="cancelBut" />
            )}
          </div>
        </div>
      );
    }
    return res;
  };

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="top-header-sec">
              <div className="col-12 mt-3">
                <h4 className="event-alert br-btm-0">
                  Sub-Account Details
                  
                </h4>

                <div className="shadowclass mt-0">{getFormAccAccount()}</div>
              </div>
            </div>

            <div className="clearfix"> &nbsp; </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};

export default AddSubAccount;
